function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .amoveo-logo-1{fill:#fff}\n      .amoveo-logo-2{fill:#fbe76c}\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(1.2515007,0,0,1.2515007,0.67107272,1.9784252)"
}, React.createElement("path", {
  transform: "translate(-252.236,-182.115)",
  className: "amoveo-logo-1",
  d: "M 270.772,195.7 Z"
}), React.createElement("path", {
  className: "amoveo-logo-1",
  d: "M 15.557,0 A 14.292,14.292 0 0 0 2.2,19.372 L 0,21.576 H 3.27 A 14.286,14.286 0 1 0 15.557,0 Z m 8.424,22.71 A 11.929,11.929 0 0 1 5.017,19.85 L 15.375,9.49 v 7.961 l 2.4,-2.4 V 3.8 L 4.079,17.5 a 11.972,11.972 0 0 1 -0.436,-3.211 11.913,11.913 0 0 1 20.338,-8.427 11.913,11.913 0 0 1 0,16.848 z"
}), React.createElement("g", {
  transform: "translate(12.337,5.746)"
}, React.createElement("path", {
  transform: "translate(-389.874,-83.939)",
  className: "amoveo-logo-2",
  d: "m 406.5,86.025 2.086,-2.086 h -3.29 l -0.014,0.014 a 14.891,14.891 0 0 1 1.218,2.072 z"
}), React.createElement("path", {
  transform: "translate(-180.22,-118.982)",
  className: "amoveo-logo-2",
  d: "m 182.621,132 v -7.961 l -2.4,2.4 v 11.251 l 13.91,-13.91 a 11.182,11.182 0 0 0 -1.065,-2.225 z"
})));

var SvgLogoAmoveo = function SvgLogoAmoveo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 40 39.999999",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoAmoveo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-amoveo.d4f7fac2.svg";
export { ForwardRef as ReactComponent };